/*
 * Вкладка «Активность»: во что человек играл и когда, как у Discord — обложка, название, «2 ч. назад»
 * и серия дней подряд. Историю пишет сервер по статусу игры из приложения для компьютера;
 * чужим она видна, только пока игра не скрыта в настройках.
 */
import { useState } from 'react'
import { Flame, Gamepad2 } from 'lucide-react'
import { BASE } from '@/lib/api'
import { formatAgo, formatDay } from '@/lib/format'
import { plural } from '@/lib/guildUi'
import type { Activity } from '@/store/social'
import type { GamePlayed } from '@/types/api'
import styles from './GameActivity.module.css'

interface Props {
  /** undefined — профиль ещё грузится. */
  games: GamePlayed[] | undefined
  /** Во что играет прямо сейчас: у этой игры вместо времени — «Сейчас в игре». */
  current?: Activity | null | undefined
  isMe: boolean
  /** Своя игра скрыта в настройках: историю видит только сам человек. */
  hidden?: boolean
}

export function GameActivity({ games, current, isMe, hidden = false }: Props) {
  if (!games) return <p className={styles.empty}>Загружаем…</p>
  if (!games.length) {
    return (
      <p className={styles.empty}>
        {isMe
          ? 'Игр пока нет. Их узнаёт приложение для компьютера, если включено «Показывать, во что играю».'
          : 'Игр пока нет.'}
      </p>
    )
  }
  return (
    <>
      {isMe && hidden ? <p className={styles.note}>Игра скрыта в настройках: эту историю видите только вы.</p> : null}
      <ul className={styles.list}>
        {games.map((g) => (
          <li key={g.name} className={styles.game} data-tooltip={`Впервые — ${formatDay(new Date(g.first_played_at))}`}>
            <Cover steam={g.steam_app_id} />
            <span className={styles.text}>
              <span className={styles.name}>{g.name}</span>
              <span className={styles.when}>{current?.name === g.name ? 'Сейчас в игре' : formatAgo(new Date(g.last_played_at))}</span>
            </span>
            {g.streak >= 2 ? (
              <span className={styles.streak}>
                <Flame size={14} aria-hidden="true" /> {g.streak} {plural(g.streak, 'день', 'дня', 'дней')} подряд
              </span>
            ) : null}
          </li>
        ))}
      </ul>
    </>
  )
}

/** Обложка из Steam через наш сервер; игры не из Steam и без обложки — значок геймпада. */
function Cover({ steam }: { steam?: string | undefined }) {
  const [broken, setBroken] = useState(false)
  if (!steam || broken) {
    return (
      <span className={styles.icon} aria-hidden="true">
        <Gamepad2 size={22} />
      </span>
    )
  }
  return <img className={styles.cover} src={`${BASE}/games/cover?steam=${encodeURIComponent(steam)}`} alt="" loading="lazy" onError={() => setBroken(true)} />
}
